/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {WorkflowScript, WorkflowScriptFromJSON, WorkflowScriptToJSON,} from './WorkflowScript';

/**
 *
 * @export
 * @interface WorkflowScriptApiResult
 */
export interface WorkflowScriptApiResult {
    /**
     *
     * @type {boolean}
     * @memberof WorkflowScriptApiResult
     */
    success?: boolean;
    /**
     *
     * @type {WorkflowScript}
     * @memberof WorkflowScriptApiResult
     */
    content?: WorkflowScript;
    /**
     *
     * @type {string}
     * @memberof WorkflowScriptApiResult
     */
    message?: string | null;
}

export function WorkflowScriptApiResultFromJSON(json: any): WorkflowScriptApiResult {
    return WorkflowScriptApiResultFromJSONTyped(json, false);
}

export function WorkflowScriptApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowScriptApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : WorkflowScriptFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WorkflowScriptApiResultToJSON(value?: WorkflowScriptApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': WorkflowScriptToJSON(value.content),
        'message': value.message,
    };
}

